module.exports = "/_next/static/images/3-7ca064d6b18a740f12d67dfc420396b6.png";